
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124292684",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5589",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M953.27858574 1019.1309824H620.79151218c-34.9986395 0-64.03609941-28.35052771-64.03609941-63.33752434V626.19383011c0-34.92878222 29.10731833-69.10077269 64.03609941-69.10077269h332.48707356c34.92878222 0 65.50310912 34.13706297 65.50310912 69.10077269v329.61127083c0 34.98699662-30.52775538 63.33752434-65.50310912 63.33752434z m0-553.36504661H620.79151218c-34.9986395 0-64.03609941-30.50446962-64.03609941-65.50310912V69.17290439c0-34.92878222 29.10731833-66.21332707 64.03609941-66.21332708h332.48707356c34.92878222 0 65.50310912 31.24961621 65.50310912 66.21332708v331.10156516c0 34.9986395-30.52775538 65.50310912-65.50310912 65.50310912zM400.6354011 1019.1309824H66.70460473a63.32588146 63.32588146 0 0 1-63.33752434-63.33752434V626.19383011c0-34.92878222 28.35052771-69.10077269 63.33752434-69.10077269h333.93079637c34.92878222 0 64.03609941 34.13706297 64.03609941 69.10077269v329.61127083c0 34.98699662-29.10731833 63.33752434-64.03609941 63.33752434z m0-553.36504661H66.70460473c-34.98699662 0-63.33752434-30.50446962-63.33752434-65.50310912V69.17290439c0-34.92878222 28.35052771-66.21332707 63.33752434-66.21332708h333.93079637c34.92878222 0 64.03609941 31.24961621 64.03609941 66.21332708v331.10156516c0 34.9986395-29.10731833 65.50310912-64.03609941 65.50310912z m-5.04138752-392.93715229H72.47949597v323.11451762h323.11451761V72.8287835z",
        "p-id": "5590"
      }
    }
  ]
})
    }
  